import React, { Fragment, useContext } from 'react';
import { useTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { ThemeContext } from '../theme';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  borderRadius: PropTypes.number
};

const defaultProps = {
  borderRadius: 0
};

const InputGroup = (props) => {
  const context = useContext(ThemeContext);
  const theme = useTheme();
  let textInput;
  if (theme && theme.textInput) {
    textInput = theme.textInput;
  } else {
    textInput = context.theme.textInput;
  }
  const {
    fontSize,
    fontWeight,
    padding,
    background,
    color,
    placeholderColor,
    caretColor,
    borderColor,
    focusedBorderColor,
    warningBorderColor,
    errorBorderColor,
    dangerBorderColor
  } = textInput;

  const styles = StyleSheet.create({
    inputGroup: {
      display: 'flex',
      background: background,
      border: `1px solid ${borderColor}`,
      borderRadius: `${props.borderRadius}px`,
      padding: '0',
      ':focus': {
        border: `1px solid ${focusedBorderColor}`,
        outline: '1px solid red'
      },
      ':focus-within': {
        border: `1px solid ${focusedBorderColor}`
      }
    }
  });

  return (
    <Fragment>
      <div
        tabIndex='-1'
        className={css(styles.inputGroup)}
      >
        {props.children}
      </div>
    </Fragment>
  );
};

InputGroup.propTypes = propTypes;
InputGroup.defaultProps = defaultProps;

export { InputGroup };
